import { IContextMenuItem } from '../../interfaces/icontext-menu-item.interface';
import { FormsComponent } from '../../../views/site/forms/forms.component';
import {
    OpenFormItemContextMenuData,
    CopyFormAsItemContextMenuData,
    ExportFormDefinitionItemContextMenuData,
    ExportAllFormCopiesItemContextMenuData,
    ShowFormImportFormatsItemContextMenuData,
    DeleteFormItemContextMenuData
} from './item-menu-classes';

export class FormsItemContextMenuData {
    // Properties.
    private itemContextMenuData: IContextMenuItem[];

    public get ItemContextMenuData(): IContextMenuItem[] {
        return this.itemContextMenuData;
    }

    // Constructor.
    public constructor(private formsComponent: FormsComponent) {
        this.itemContextMenuData = [
            new OpenFormItemContextMenuData('Open', this.formsComponent),
            new CopyFormAsItemContextMenuData('Copy As ...', this.formsComponent),
            new ExportFormDefinitionItemContextMenuData('Export Form Definition ...', this.formsComponent),
            new ExportAllFormCopiesItemContextMenuData('Export All Copies ...', this.formsComponent),
            new ShowFormImportFormatsItemContextMenuData('Show Import Format Examples ...', this.formsComponent),
            new DeleteFormItemContextMenuData('Delete ...', this.formsComponent),
        ];
    }
}
